import Footer from '@/components/footer/footer'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from 'vuex-class'
import HeaderPerfil from '@/components/profile/profile'

@Component({
  components: {
    HeaderPerfil,
    Footer
  }
})
export default class Perfil extends Vue {

}
